<template>
  <div>
    <new-main-header
        v-if="hasNewLeftNavEnabled"
        :show-plc-button="!isFraud"
        :show-one-off-button="!isFraud">
      Customer History
    </new-main-header>
    <main-header
        v-else
        :show-plc-button="!isFraud"
        :show-one-off-button="!isFraud">
      <span slot="arrow-back">
        <el-tooltip
            class="item"
            effect="dark"
            content="Back to Start Page"
            placement="bottom-start">
          <router-link :to="{ name: 'HomePage' }"><i class="el-icon-back" /> </router-link>
        </el-tooltip>
      </span>
      <span slot="page-title">Customer Requests</span>
    </main-header>
    <main-content>
      <div slot="main-content">
        <el-card
            body-style="padding: 0px; margin: 0px;"
            style="border-radius: 8px 8px 0 0 !important;">
          <div>
            <div class="header-pane">
              <div class="requests-header">
                Requests
              </div>
              <div class="custom-tabs">
                <el-tabs
                    v-model="activeName"
                    class="is-active"
                    @change="clearSearch()">
                  <el-tab-pane
                      name="orders">
                    <span slot="label">
                      Orders
                    </span>
                  </el-tab-pane>
                  <el-tab-pane
                      name="returns">
                    <span slot="label">
                      Returns</span>
                  </el-tab-pane>
                  <el-tab-pane
                      name="replacements"
                      disabled>
                    <span slot="label">
                      Replacements
                    </span>
                  </el-tab-pane>
                  <el-tab-pane
                      name="send_parts/one_off"
                      disabled>
                    <span slot="label">
                      Send Parts/One-off
                    </span>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div
                id="search-div"
                class="search-box">
              <el-input
                  v-model="searchInput"
                  type="text"
                  class="search-box-body"
                  placeholder="Search by order ID, date or Ring device..." />
            </div>
            <OrderTable
                v-if="activeName=='orders'"
                :search-value="searchInput"
                @current-order="setCurrentOrder" />
            <ReturnTable
                v-if="activeName=='returns'"
                :search-value="searchInput" />
          </div>
        </el-card>
      </div>
    </main-content>
    <OrderDetails
        v-if="detailsVisible"
        :visible.sync="detailsVisible"
        :order-number="currentOrder"
        @change-active="changeActiveTab" />
  </div>
</template>

<script>
import OrderDetails from "./OrderDetails.vue";
import axios from "axios";
import { createNamespacedHelpers as h } from "vuex";
import OrderStatus from "./OrderStatus";
import ReturnTable from "./Return/ReturnTable";
import MainHeader from "../../Core/Header/MainHeader.vue";
import MainContent from "../../Core/MainContent.vue";
import helper from "@/helpers/TimeZoneFormatterHelper";
import OrderTable from "./OrderTable";
import NewMainHeader from "@/NewUI/containers/core/header/MainHeader";
import permission from "@/mixins/permission";
import { get } from "lodash";

const { mapGetters: accountGetters } = h("db/account");

export default {
  name: "OrderWidget",
  components: {
    OrderTable,
    MainContent,
    MainHeader,
    OrderStatus,
    OrderDetails,
    ReturnTable,
    NewMainHeader,
  },
  mixins: [permission],
  data() {
    return {
      detailsVisible: false,
      activeName: "orders",
      currentOrder: "",
      searchInput: "",
      loading: false,
      search: "",
      orders: [],
      all_orders: [],
    };
  },
  computed: {
    ...accountGetters(["customerId"]),
    hasNewLeftNavEnabled() {
      return this.hasPermission("NewUI", "leftNav");
    },
    isFraud() {
      return get(this.customer, "profile.fraud", false);
    },
  },
  watch: {
    activeName: function (newVal, oldVal) {
      this.searchInput = "";
      if (newVal == "orders") {
        this.detailsVisible = false;
      }
    },
  },
  mounted() {
    // Redirect to home if accessing /orders without orderId
    if (this.$route.path === "/orders" && !this.$route.query.orderId) {
      this.$router.push({ name: "HomePage" });
      return;
    }

    if (this.$route.query.orderId) {
      this.setCurrentOrder(this.$route.query.orderId);
    }
    this.loadOrders();
  },
  methods: {
    changeActiveTab(value) {
      if (value == "return") {
        this.activeName = "returns";
      }
    },
    loadOrders() {},
    openDetails() {
      this.detailsVisible = true;
    },
    setCurrentOrder(id) {
      this.currentOrder = id;
      this.detailsVisible = true;
    },
    clearSearch() {
      this.searchInput = "";
    },
  },
};
</script>

<style>
.el-table.requests td {
  vertical-align: baseline !important;
}
.requests-header {
  /* Heading */
  height: 30px;

  /* heading/small-medium */

  font-family: Equip;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* 🖥 light/content/base */

  color: #424242;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.tab-headers {
  /* Tab Name */

  height: 24px;

  /* body/normal-medium */

  font-family: Equip;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  display: flex;
  align-items: center;

  /* Light/Content/Base */

  color: #6e6e6e;
  border-bottom: 0px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.header-pane {
  /* Heading */

  /* Auto layout */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 24px 0px;
  gap: 16px;
  height: 102px;

  /* 🖥 light/surface/base

  Background color of components, and page background (when white)

  White 900
  */
  background: #ffffff;
  /* Border Bottom

  For cases when a border element cannot be used or when border will need to transition between a shadow and border efficiently in code (ie. Toast Notifications)
  */
  box-shadow: inset 0px -1px 0px #dee5ec;
  border-radius: 8px 8px 0px 0px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.custom-tabs::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 0px;
}

.active-tab {
  color: #000000 !important;
}

.el-table.orders column-header {
  /* Table Columns Header */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 8px 8px 24px;
  gap: 16px;

  height: 54px;

  /* 🖥 light/tertiary/background

  Tertiary 300
  */
  background: #f6f8fa;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.search-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 52px;
  border-bottom: 1px solid #dee5ec;

  input {
    border: 0;
  }
}

.search-box-body {
  font-family: Equip, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #6e6e6e;
}
.order-id-text {
  /* #1108554 */

  /* textlink (inline) /normal-medium

  Use Primary 400 for inline text links
  */
  font-family: Equip;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  padding: 0px 10px;
  /* identical to box height, or 171% */

  display: flex;
  align-items: center;
  text-decoration-line: underline;

  /* 🖥 light/primary/base */

  color: #1998d5;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.order-table-header {
  background: #f6f8fa !important;
  font-weight: normal !important;
}
.el-tabs__item {
  color: #6e6e6e !important;
}
.el-tabs__item.is-active {
  color: #000000 !important;
}
.el-tabs__nav-wrap::after {
  width: 0 !important;
}
.el-table .sort-caret.descending {
  border-top-color: #c0c4cc;
  bottom: 15px;
  margin-bottom: 4px;
}
.el-table .sort-caret.ascending {
  border-bottom-color: #c0c4cc;
  top: 5px;
  display: none;
}
.el-table__body {
  border-collapse: collapse !important;
}
.el-table__row {
  border-bottom: 1px solid rgba(66, 66, 66, 0.1) !important;
}
</style>
